// @ts-nocheck
import { getCubaREST } from "@cuba-platform/react";
import { JobDescriptionRequestKzm } from "../../../cuba/entities/kzm_JobDescriptionRequestKzm";
import { rootStore } from "../../store";
import { useQuery } from "react-query";

export const useJobDescriptionRequests = () => {
  return useQuery({
    queryKey: ["jobDescriptionRequests", rootStore.userInfo.login],
    queryFn: async () => {
      return await getCubaREST().searchEntities<JobDescriptionRequestKzm>(
        JobDescriptionRequestKzm.NAME,
        {
          conditions: [
            {
              property: "createdBy",
              operator: "=",
              value: rootStore.userInfo.login,
            },
          ],
        },
        {
          view: "jobDescriptionRequest-browse",
          sort: "-updateTs",
        },
      );
    },
    enabled: !!rootStore.userInfo.login,
  });
};
